export const MODES = [
  { id: 'normal', name: 'Normal' },
  { id: 'bell', name: 'Bell Subgroup' },
  { id: 'derivative', name: 'Derivative Subgroup' },
  { id: 'appell', name: 'Appell Subgroup' },
  { id: 'associated', name: 'Associated (Lagrange) Subgroup' },
  { id: 'twobell', name: '2-Bell Subgroup' },
];
